import { httpClient } from './httpClient';
import { CategoryItem, AddDepartment, DepartmentItem, AddCategoryItem } from '../types/category';

export async function getAllCategory(type: string): Promise<CategoryItem[]> {
  const response = await httpClient.sendRequest({
    url: `category_management?type=${type}`,
    method: 'GET',
  });
  return response.data;
}
export async function addCategory(payload: AddCategoryItem): Promise<CategoryItem> {
  const response = await httpClient.sendRequest({
    url: 'category_management',
    method: 'POST',
    data: payload,
  });
  return response.data;
}
export async function getAllDepartment(): Promise<DepartmentItem[]> {
  const response = await httpClient.sendRequest({
    url: `categories`,
    method: 'GET',
  });
  return response.data;
}

export async function addDepartment(payload: AddDepartment): Promise<DepartmentItem> {
  const response = await httpClient.sendRequest({
    url: 'categories',
    method: 'POST',
    data: payload,
  });
  return response.data;
}
export async function updateDepartment(payload: DepartmentItem): Promise<DepartmentItem> {
  const response = await httpClient.sendRequest({
    url: 'categories',
    method: 'PUT',
    data: payload,
  });
  return response.data;
}

export async function updateCategory(payload: CategoryItem): Promise<CategoryItem> {
  const response = await httpClient.sendRequest({
    url: `category_management/${payload.id}`,
    method: 'PUT',
    data: payload,
  });
  return response.data;
}
